import { fetchAPIColumnOptions } from "../../api/application/table-appendix";
import type { TableForm } from "../../api/infrastructure/table-appendix.formatter";
import type { SchemaFieldOption } from "../../helpers/format-databases";

export async function getTableColumnOptions(field: TableForm): Promise<SchemaFieldOption[]> {
  if (field.type !== "enum") return [];
  if (!field.data_source) return [];
  if (field.data_source.type === "key_value" && field.data_source.values) {
    return field.data_source.values.map((val) => ({
      key: val.key,
      value: val.value,
    }));
  }
  if (
    (field.data_source.type === "api" || field.data_source.type === "relation") &&
    field.data_source.apiUrl
  ) {
    const values = await fetchAPIColumnOptions(field.data_source.apiUrl);
    return values;
  }
  return [];
}
